<template>
  <div
    class="flex flex-col justify-center"
    :class="centered ? 'items-center' : 'items-start'"
    style="height: 100%"
  >
    <p
      v-if="showRatingNumber"
      class="text-center font-bold"
      style="line-height: normal !important;">
      {{ value | fixed_number(1) }}
    </p>
    <div
      :class="centered ? 'flex justify-center' : 'flex justify-start'"
      style="line-height: normal !important;">
      <star-rating
        :rating="value"
        :increment="0.1"
        :round-start-rating="false"
        :show-rating="false"
        read-only
        :star-size="size"/>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'ReviewsSettingsCellRendererRating',
  components: {
    StarRating,
  },
  props: {
    isAgGridComponent: {
      type: Boolean,
      default: true,
    },
    rating: {
      type: Number,
      default: 0,
    },
    showRatingNumber: {
      type: Boolean,
      default: true,
    },
    centered: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    value() {
      if (this.rating) return this.rating;

      return (this.params && this.params.value ? this.params.value : null);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
